import _ from 'lodash';
import Vue from 'vue'

let me = {
    name: 'PageNavigator::API',
    api: window.api,
    pc: 0,
    maxVisitedPageIndex: 0,
    skip_twice: 0
}

me.setClientAPI = (c) =>  {
    me.api = c;

    me.api.eventSubscribe(me, [me.api.events.EVENT_ON_CREATE,me.api.events.EVENT_ON_UPDATE ], () => {
        me.skip_twice = 0
    })
}


me.getPages = () => {
    const root = me.api.getSchema()?.elements
    const roots = Array.isArray(root) ? root : [root]
    const pages = []
    const visited = new WeakSet()

    const walk = (node, ancestorPaused = false) => {
        if (!node || visited.has(node)) return
        visited.add(node)

        const effectivelyPaused = false && (ancestorPaused || !!node.paused)
        if ((node.propsData || {}).isFormPage && !effectivelyPaused) {
            pages.push(node)
        }

        (node.children || []).forEach(child => walk(child, effectivelyPaused))
    }

    roots.forEach(node => walk(node, false))
    Vue.set(me.api.getContext(), 'totalPages', pages.length);
    return pages
}

me.getCurrentPageNode = () => {
    let currentPageNdx = me.getCurrentPageIndex();
    let formPages = me.getPages()
    if (!formPages || !formPages[currentPageNdx]) return;    // formularios sin paginas
    var currentPageElement = formPages[currentPageNdx]

    return currentPageElement;
}


me.validateCurrentPage = () => {
    let currentPageNode = me.getCurrentPageNode();
    if (!currentPageNode) return;    // formularios sin paginas
    let r = me.api.validateElem(currentPageNode);
    me.api.eventPublish(me.api.events.EVENT_ON_PAGE_VALIDATION, { detail: r })

    if (r?.length )
        me.api.eventPublish(me.api.events.EVENT_ON_PAGE_VALIDATION_ERRORS, { detail: r })

    return r;
}

// params = { plus: 1, validate: false, executeEvents: true}
me.changePage = (params) => {
    let context = me.api.getContext();

    me.api.clearValidationErrors()

    if (!params) return;

    // impide que se pueda volver atras en la ultima pagina
    if (params.preventBackOnLastPage) {
        if (me.getCurrentPageIndex() === (context.totalPages - 1)) return;
    }

    if (params.executeEvents === undefined) {
        params.executeEvents = true
    }

    if (params.validate) {
        let errors = me.validateCurrentPage()
        if (errors && errors.length) return;
    }

    let targetPageIndex = me.getCurrentPageIndex() + params.plus;
    if (targetPageIndex >= (context.totalPages || 0)) targetPageIndex = context.totalPages - 1;
/*
    let currentPageElement = me.api.getVueElementForNode( me.getCurrentPageNode() );
    let handlerTargetPage = me.api.getVueElementForNode( me.getCurrentPageNode() );
    if (currentPageElement.node.nodeUUID != handlerTargetPage.node.nodeUUID) {
        targetPageIndex = me.getPageIndex(handlerTargetPage);
    }
    */
    me.setCurrentPageComposite(targetPageIndex)
}

me.setCurrentPageComposite = (targetPageIndex, params) => {

    me.setCurrentPage(targetPageIndex, params);

    const url = new URL(window.location);
    const hashQueryIndex = url.hash.indexOf('?');

    if (hashQueryIndex >= 0) {
        const hashParams = new URLSearchParams(url.hash.slice(hashQueryIndex + 1));
        hashParams.forEach((value, key) => {
            if (key !== 'id') url.searchParams.append(key, value);
        });
    }

    url.searchParams.set('id', window.api.schema.id);
    url.hash = '';

    window.history.pushState(targetPageIndex,targetPageIndex, url);
    // window.document.title = me.getPages()[targetPageIndex].name

    me.maxVisitedPageIndex = Math.max(me.maxVisitedPageIndex, me.getCurrentPageIndex())
}

me.setPage = (pageName, params) => {
    const targetName = me.api.eval(pageName)
    const pages = me.getPages()

    let targetPageIndex = _.findIndex(
        pages,
        p => p.name === targetName && !!me.api.getVueElementForNode(p)
    )

    if (targetPageIndex < 0) {
        targetPageIndex = _.findIndex(pages, { name: targetName })
    }

    if (targetPageIndex < 0) {
        window.console.warn('setPage: page not found', { targetName })
        return
    }

    window.console.log('setPage', { targetPageIndex, targetName })
    me.setCurrentPageComposite(targetPageIndex, params)
}

me.getCurrentPageIndex = () => me.api.getContext().currentPage;
me.getCurrentPageProperty = (prop) => me.api.eval((me.getCurrentPage()?.propsData ||{})[prop] || (me.getCurrentPage()||{})[prop])
me.getCurrentPage = (prop) => prop? me.getCurrentPageProperty(prop) : me.api.getPages()[me.api.getContext().currentPage];
me.getMaxVisitedPageIndex = (after) => {
    if (after == undefined) return me.maxVisitedPageIndex
    return me.maxVisitedPageIndex > after
}
me.getPageIndex = (p) => _.findIndex(me.getPages(), { nodeUUID: p.nodeUUID})
me.nextPage = () => me.changePage({ plus: 1, validate: true, executeOnChangeEvent: true })
me.previousPage = () => me.changePage({ plus: -1, validate: false, executeOnChangeEvent: false })
me.previousPageNoBack = () => me.changePage({ plus: -1, validate: false, executeOnChangeEvent: false, preventBackOnLastPage: false })
me.isAfterPage = (k) => me.getCurrentPageIndex() > k
me.isBeforePage = (k) => me.getCurrentPageIndex() < k
me.isLastPage = () => me.getCurrentPageIndex() >= me.api.getContext().totalPages - 1
me.isFirstPage = () => !me.getCurrentPageIndex()
me.isCurrentPage = (element) => (element.nodeUUID === me.getCurrentPageNode()?.nodeUUID) || (me.getCurrentPageNode()?.name === element)

// no meter aqui history.pushState. Ver browserbuttonnavigator
me.setCurrentPage = (value, params) => {
    if (!me.api.getPages().length) return
    if (value < 0) value = 0;

    let currentPageElement = me.api.getVueElementForNode( me.getCurrentPageNode() ) ||{};
    me.api.executeHandler((currentPageElement.propsData || {}).onExit, currentPageElement)

    // invocamos pageOnExit() en la pagina del nodo saliente y sus hijos
    me.api.applyAllVueChildren( n => n.pageOnExit ? n.pageOnExit(params) : null, currentPageElement);


    let fromPage = me.getCurrentPageIndex()
    me.api.commit("setCurrentPage", value)
    if (fromPage != value) {
        me.api.eventPublish(me.api.events.EVENT_ON_PAGE_CHANGE, {
            detail: {
                fromPage,
                toPage: value
            }
        })

        try {
            me.api.eventPublish(me.getPages()[value]?.name)
        } catch(err) {
            // Ignorar el error ..
        }
    }

    me.api.clearValidationErrors()
    Vue.nextTick( () => {
        let enteringPage = me.api.getVueElementForNode( me.getCurrentPageNode() );
        if (enteringPage?.name === currentPageElement?.name) {
            if (me.skip_twice) return
            me.skip_twice++
        }
        if (enteringPage) {
            me.api.executeHandler((enteringPage.propsData || {}).onEnter, enteringPage)
            console.log('enteringPage pageOnEnter', enteringPage?.name, currentPageElement?.name)
            me.api.applyAllVueChildren( n => n.pageOnEnter ? n.pageOnEnter(params) : null, enteringPage);
        }
    })

    me.api.scrollTo('scroll_on_page_change')
}


export default me
